import React from 'react'
import { ChartBarHorizontalCustom } from '../../components'
import { Card, H3, Para, Stats, Values, Row, ProgressBar } from './styleCustomToolTip1'
import { getObjectAsArray, addZero } from '../../util'

const CustomTootTip1 = ({ data, type, insightsElementType }) => {
  const obj = data.data.otherDetails
  const otherDetails = obj?.otherDetails ? { ...obj.otherDetails } : { ...obj }
  const finalData =
    getObjectAsArray(
      otherDetails?.DriverAttributes?.DriverAttributeElement ||
        otherDetails?.DriverSubAttributes?.DriverSubAttributeElement
    ) || []
  const maxValue = Math.max(...finalData.map((d) => d.Percent))

  return (
    <Card type={type}>
      <Values className='percentValue' type='none'>
        <strong>{addZero(otherDetails.Percent)}%</strong>
      </Values>
      <H3>
        {otherDetails?.DriverName || otherDetails?.AttributeName || otherDetails?.SubAttributeName}
      </H3>
      <Para>{data.data.fullLabel}</Para>
      {['DriversProgression3Level'].includes(insightsElementType) && (
        <Stats dataLength={finalData.length}>
          <Values type='Positive'>
            <strong>{addZero(otherDetails.PositivePercent)}%</strong> Positive
          </Values>
          <Values type='Mixed'>
            <strong>{addZero(otherDetails.MixedPercent)}%</strong> Mixed
          </Values>
          <Values type='Negative'>
            <strong>{addZero(otherDetails.NegativePercent)}%</strong> Negative
          </Values>
        </Stats>
      )}

      {[...finalData].slice(0, 5).map((d, i) => {
        let array = [
          {
            Positive: d.PositivePercent,
            Neutral: d.NeutralPercent,
            Mixed: d.MixedPercent,
            Negative: d.NegativePercent,
          },
        ]
        if (['DriversProgressionWithoutSentiments3Level'].includes(insightsElementType)) {
          array = [{ WithoutSentiments: d.Percent }]
        } else if (['SearchDriversProgression3Level'].includes(insightsElementType)) {
          array = [{ SearchKeywords: d.Percent }]
        }
        return (
          <React.Fragment key={`id_${d.InsightsElementId}_${i}`}>
            <Row>
              <span>{d?.AttributeName || d?.SubAttributeName}</span>
              <span>{d.Percent}%</span>
            </Row>
            <ProgressBar>
              <ChartBarHorizontalCustom
                data={array}
                showInside={false}
                bottomText={false}
                valueInPercent={true}
                maxPercentRatio={maxValue || 100}
                maxWidth='100%'
              />
            </ProgressBar>
          </React.Fragment>
        )
      })}
    </Card>
  )
}

export default CustomTootTip1
